import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['session']),
    isAuthenticated() {
      return this.session.user !== null;
    },
  },
};